import { HelpCircle } from "lucide-react";
import { Link, useHref } from "react-router";

interface HelpLinkProps {
  to: string;
  label: string;
  size?: number;
  // Open the guide page in a new tab. Default for contextual icons embedded in
  // the working surface (assessment, blueprint, threshold tooltip) so the
  // recruiter keeps their place. Pass false from inside the guide itself or
  // from a dedicated "read more" link where a same-tab navigation is fine.
  newTab?: boolean;
}

export function HelpLink({ to, label, size = 12, newTab = true }: HelpLinkProps) {
  const className = "inline-flex items-center text-text-faint hover:text-accent";
  // useHref resolves the path against the BrowserRouter basename ("/app"), so
  // a plain anchor lands at /app/help/... not /help/... .
  const href = useHref(to);
  if (newTab) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        title={label}
        aria-label={label}
        className={className}
      >
        <HelpCircle size={size} />
      </a>
    );
  }
  return (
    <Link to={to} title={label} aria-label={label} className={className}>
      <HelpCircle size={size} />
    </Link>
  );
}
